<script lang="ts" setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useNotifications } from "@/stores/notifications.ts";
import { Status } from "@/classes/Notification.ts";
import { CheckCircleIcon, XMarkIcon } from "@heroicons/vue/24/outline";

const notifications = useNotifications();

const { current } = storeToRefs(notifications);

const colour = computed(() => {
  return current.value?.status === Status.SUCCESS ? "text-green-400" : "text-red-400";
});

const onClose = () => notifications.pop(current.value!);
</script>

<template>
  <div
    aria-live="assertive"
    class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
  >
    <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <transition
        enter-active-class="transform ease-out duration-300 transition"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="current"
          class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5"
        >
          <div class="p-4">
            <div class="flex items-start">
              <div class="shrink-0">
                <CheckCircleIcon :class="['size-6', colour]" aria-hidden="true" />
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-gray-900">{{ current!.title }}</p>
                <p class="mt-1 text-sm text-gray-500">{{ current!.message }}</p>
              </div>
              <div v-show="current.ttl === undefined" class="ml-4 flex shrink-0">
                <button
                  class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                  type="button"
                  @click="onClose"
                >
                  <span class="sr-only">Sluiten</span>
                  <XMarkIcon aria-hidden="true" class="size-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style scoped></style>
